import React from "react";
import { ComponentProjectListRequestPageInitialState, PageNewState } from ".";

export const ComponentProjectListRequestPageContext = React.createContext({
  pageState: ComponentProjectListRequestPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
